import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { firstValueFrom, lastValueFrom, Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RateManagerService {
  protected endpoint?: string;

  constructor(private apiService: ApiService) {
    this.endpoint = 'rate-manager';
  }

  cleanPayload(rawPayload: any) {
    return Object.fromEntries(
      Object.entries(rawPayload).filter(([_, v]) => v !== null)
    );
  }

  getRates(payload: any = {}) {
    payload = this.cleanPayload(payload);

    const isDownloadCsv = payload.download_csv === true;

    if (isDownloadCsv) {
      const options = { responseType: 'text' as const };
      return this.apiService.get(
        `${this.endpoint}/provider/rates`,
        payload,
        false,
        options
      );
    }

    return this.apiService.get(
      `${this.endpoint}/provider/rates`,
      payload,
      true
    );
  }

  createRate(payload: any = {}) {
    payload = this.cleanPayload(payload);
    return this.apiService.post(`${this.endpoint}/provider/rates`, payload);
  }

  bulkCreateRate(formData: FormData) {
    // Send FormData directly; do NOT clean it
    return this.apiService.uploadFile(
      `${this.endpoint}/provider/upload-rate`,
      formData
    );
  }

  async getProviderRatesCategories(payload: object = {}, skipInterceptor: boolean = false) {
    payload = this.cleanPayload(payload);
    return await firstValueFrom(
      this.apiService.get(`${this.endpoint}/provider/rates-categories`, payload, skipInterceptor)
    );
  }

  async getLocation(payload: object = {}, skipInterceptor: boolean = false) {
    payload = this.cleanPayload(payload);
    return await firstValueFrom(
      this.apiService.get(
        `${this.endpoint}/provider/rates-locations`,
        payload,
        skipInterceptor
      )
    );
  }

  async getProviderRatesSubCategories(id: number, payload: object = {}) {
    payload = this.cleanPayload(payload);
    return await firstValueFrom(
      this.apiService.getById(
        `${this.endpoint}/provider/rates-sub-categories`,
        payload,
        id
      )
    );
  }

  updateRateStatus(id: number, payload: object = {}) {
    payload = this.cleanPayload(payload);
    return this.apiService.put(
      `${this.endpoint}/provider/rates-status/${id}`,
      payload
    );
  }

  downloadRateTemplate(categoryId: number) {
    const options = { responseType: 'text' as const };
    return this.apiService.get(
      `${this.endpoint}/provider/download-rate-template/${categoryId}`,
      {},
      false,
      options
    );
  }
}
